module.exports = __webpack_public_path__ + "img/research-group-6.3c61ba7e.jpg";